// extracted by mini-css-extract-plugin
export default {"button_wrapper":"TransparentButton_button_wrapper__fjLZx","transparent_button":"TransparentButton_transparent_button__uE-hi"};